import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import QuantityList     from './QuantityList'
import ProductList      from './ProductList'
import PriceList        from './PriceList'

import styles from './Overview.module.css';


@inject('core')
@observer
export default class NewProductButton extends React.Component {
	
	constructor(props) {
		super(props)
		this.click  = this.click.bind(this)
	}
	
	componentDidMount() {
		const { core } = this.props
	}
	
	click() {
		const { core } = this.props
		
		var name = window.prompt('Product Name', '')
		if ((typeof name !== 'undefined') && (name !== null) && (name.length)) {
			const uuid = core.uuid('p')
			core.action({
				op:'addProduct', 
				product_id: uuid, 
				name: name
			})
		}
	}

	render() {
		const { core } = this.props
		
		return <span className="inline-button" onClick={this.click}>+ New Product</span>
	}
	
}
